/**
 * @generated SignedSource<<8f485a343a483d64fe739b331dd94e96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PendingInvitesList_invites$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PendingInviteItem_invite">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PendingInvitesList_invites";
};
export type PendingInvitesList_invites$key = {
  readonly " $data"?: PendingInvitesList_invites$data;
  readonly " $fragmentSpreads": FragmentRefs<"PendingInvitesList_invites">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PendingInvitesList_invites",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InviteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Invite",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PendingInviteItem_invite"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InviteConnection",
  "abstractKey": null
};

(node as any).hash = "e63dbcd3ab8de9f14d005234f9dbd73f";

export default node;
